import { Key } from 'constants/keyboard';
import { WIDGET_MENU_OPTIONS } from 'types/WidgetMenu.types';
import { AccessibilityViewIndex } from 'types/accessibilityViewIndex';

export interface EditorSettingsState {
  zoom: number;
  isSlideView: boolean;
  accessibilityViewIndex: AccessibilityViewIndex;
  /**
   * Apply different visual simulator filter to page canvas, default to none.
   */
  colorVisionMode: ColorVisionMode;

  // Set to TRUE if the right side menu widget settings is open
  isWidgetSettingsView: boolean;

  // current left menu opened;
  activeWidgetMenu: WIDGET_MENU_OPTIONS;
  // the tab index of the replace widget menu
  replaceWidgetMenuIndex: number;

  hasKeyboardIgnore: boolean;
  allowedKeyboardKeys: Key[];
  downloadModal: { isOpen: boolean; trigger: DownloadModalTrigger };
  originalEditorId?: string;
  chartWidgetSettingsTabIndex: number;

  /**
   * flag to indicate language set by user manually once
   */
  languageUpdatedOnce: boolean;

  /**
   * The brand index indicating the current brand used on the editor
   * For example,
   *  all brands ['Brand 1', 'Brand 2', 'Brand 3', 'Brand 4]
   * Then this index 2 means 'Brand 3'
   */
  brandIdx: number;

  // Flag to indicate if the keyboard shortcut modal for browser specific copy/paste is open
  keyboardShortcutModalOpen: boolean;

  // Flag to indicate if the grid should be shown on the Page
  hasShowGrid: boolean;
  // Flag to indicate if the margin should be shown on the Page
  hasShowMargin: boolean;

  // RTC is enabled for team sharing
  isTeamSharingEnabled: boolean;
  showCollaborationWarning: boolean;

  // Flag to indicate if the editor is uploading a file
  isUploading: boolean;

  // Flag to indicate if the edit background menu is open,
  // and which tab opened, color or pattern
  editBackgroundView?: EditBackgroundType;

  isViewOnly: boolean;

  // Flag to indicate if alt text tag should be shown on canvas when widgets are selected
  showAltTagOnCanvas: boolean;

  // Flag to indicate if alt text has been edited at least once
  hasEditedAltText: boolean;
}

export enum DownloadModalTrigger {
  Default = '',
  Navbar = 'Navbar',
  ShareButton = 'ShareButton',
  AccessibilityMenu = 'AccessibilityModal',
  AccessibilityMenuDownloadButton = 'AccessibilityMenuDownloadButton',
}

export enum ColorVisionMode {
  none = 'none',
  achromatopsia = 'achromatopsia',
  deuteranopia = 'deuteranopia',
  protanopia = 'protanopia',
  tritanopia = 'tritanopia',
  cataracts = 'cataracts',
  lowvision = 'lowvision',
}

export enum ReplaceMenuTabIndex {
  ICON = 0,
  PHOTO = 1,
  UPLOAD = 2,
}

export type EditBackgroundType = 'color' | 'pattern' | undefined;
